import { render, staticRenderFns } from "./Scenic.vue?vue&type=template&id=10d6f43c&scoped=true&"
import script from "./Scenic.vue?vue&type=script&lang=js&"
export * from "./Scenic.vue?vue&type=script&lang=js&"
import style0 from "./Scenic.vue?vue&type=style&index=0&id=10d6f43c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6f43c",
  null
  
)

export default component.exports